var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLocation = function SvgLocation(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 9c0-3.197 2.749-5.5 5.5-5.5s5.5 2.303 5.5 5.5c0 .882-.334 1.859-.876 2.854-.54.99-1.267 1.96-2.004 2.82A28.329 28.329 0 0 1 10 17.339a28.31 28.31 0 0 1-2.62-2.663c-.737-.86-1.464-1.83-2.004-2.82C4.833 10.858 4.5 9.881 4.5 9Zm5.18 9.384L10 18l-.32.384a.5.5 0 0 0 .64 0L10 18l.32.384.002-.001.004-.003.014-.012.052-.045.196-.17a29.313 29.313 0 0 0 2.791-2.827c.764-.89 1.537-1.92 2.122-2.993.583-1.067.999-2.215.999-3.333 0-3.803-3.251-6.5-6.5-6.5S3.5 5.197 3.5 9c0 1.118.417 2.266.999 3.333.585 1.073 1.358 2.102 2.121 2.992a29.331 29.331 0 0 0 2.988 2.998l.052.045.014.012.004.003h.001ZM8.5 9a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM10 6.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z",
    fill: "currentColor"
  })));
};
export default SvgLocation;